import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'working-list',
  templateUrl: './working-list.component.html',
  styleUrls: ['./working-list.component.scss'],
})
export class WorkingListComponent implements OnInit {
  @Input() mapEvent: google.maps.Map;
  @Input() data: any;

  @Output() onFilter = new EventEmitter<string>();
  @Output() onItemSelected = new EventEmitter<any>();

  searchTerm: FormControl;
  selectedItem: any;

  ngOnInit(): void {
    this.searchTerm = new FormControl();

    this.searchTerm.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((value) => this.onFilter.emit(value));
  }

  selectItem(item: any) {
    this.selectedItem = item;
    this.onItemSelected.emit(item);
  }

  zoomToLocation(lat: number, lng: number) {
    const newLatLng = new google.maps.LatLng(lat, lng);
    this.mapEvent.setCenter(newLatLng);
    this.mapEvent.setZoom(15);
  }
}
